module.exports = __webpack_public_path__ + "static/media/bg10.f0d38d4c.jpg";